import { Transaction } from 'prosemirror-state';
import { DecorationSet } from 'prosemirror-view';

/**
 * Dim overlapping selections in the given decoration set based on the current transaction's selection.
 * @param tr - The current transaction.
 * @param decorationSet - The decoration set to modify.
 */

export function dimOverlappingSelections(
  tr: Transaction,
  decorationSet: DecorationSet,
) {
  const { selection } = tr;
  // `Decoration.type` is private
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  decorationSet.find().forEach((deco: any) => {
    if (deco.type.toDOM) {
      if (deco.from === selection.from && deco.to === selection.to) {
        // When own cursor is at the same position where remote cursor.
        // Add opacity to remote cusros
        // and set it to be drawn before own cursor
        deco.type.toDOM.classList.add('telepointer-dim');
        deco.type.side = -1;
      } else {
        deco.type.toDOM.classList.remove('telepointer-dim');
        deco.type.side = 0;
      }
    }
  });
}
